// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3ymr3","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__DWuj2"};